import type { OptionalCharge } from '@/components/shared/types'

export function computeChargesTotal(charges: OptionalCharge[]): number {
  const sum = charges.reduce((acc, charge) => acc + (charge.amount || 0), 0)
  return Math.round(sum * 100) / 100
}
